import { Injectable, EventEmitter } from '@angular/core';


@Injectable()
export class GlobalEventService {

  public footerVisibility: EventEmitter<boolean> = new EventEmitter<boolean>();
  
  constructor() { }
  
}
